// audio Player
export let audioPlayer = () => {

    if($('body').hasClass('blog')){

        var audioInner = $('.section--post__audio__inner'),
            audioPlayer = $('#news-audio'),
            audioPlayerPost = $('.section--post__audio__post'),
            audioPlayerSrc = $('.section--post__audio__player audio source'),
            audioItem = $('.news-audio__item'),
            audioItemFirst = $('.news-audio__item:first-child'),

            initaudioItemURL = audioItemFirst.attr('data-url'),
            initaudioItemTitle= audioItemFirst.children('h6').clone(),
            initaudioItemTime = audioItemFirst.children('time').clone();

        // Audio initial setup
        if(initaudioItemURL !== undefined){

            audioPlayerPost.prepend(initaudioItemTitle);
            audioPlayerPost.prepend(initaudioItemTime);

            audioPlayer[0].pause();

            audioPlayerSrc.attr('src', initaudioItemURL); 
            audioItemFirst.addClass('news-videos__item--active');
            audioItemFirst.find('.cms-link').text('Now Playing');

            audioInner.addClass('section--post__audio__inner--active');

            audioPlayer[0].load();

        }

        // Audio On click
        audioItem.on('click keypress', function(e){
                
            var audioItemURL = $(this).attr('data-url'),
                audioItemTitle= $(this).children('h6').clone(),
                audioItemTime = $(this).children('time').clone();

            if(audioItemURL !== undefined){

                e.preventDefault();

                audioPlayer[0].pause();

                audioItem.removeClass('news-videos__item--active');
                audioItem.find('.cms-link').text('Watch');

                $(this).addClass('news-videos__item--active');
                $(this).find('.cms-link').text('Now Playing');

                audioInner.addClass('section--post__audio__inner--active');

                audioPlayerPost.css('opacity', 0);
                audioPlayerPost.html('');

                setTimeout(() => {
                    audioPlayerPost.prepend(audioItemTitle);
                    audioPlayerPost.prepend(audioItemTime);

                    audioPlayerSrc.attr('src', audioItemURL);  

                    audioPlayer[0].load();
                }, 1000);

                setTimeout(() => {
                    audioPlayerPost.css('opacity', 1);
                }, 1500);

            }

        });   

    }

};